import { render, staticRenderFns } from "./SearchResultExplain.vue?vue&type=template&id=0045f840&scoped=true&"
import script from "./SearchResultExplain.vue?vue&type=script&lang=js&"
export * from "./SearchResultExplain.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultExplain.vue?vue&type=style&index=0&id=0045f840&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0045f840",
  null
  
)

export default component.exports